export default __webpack_public_path__ + "static/media/marker-AV.c35eb72d.svg";